import React from 'react';

import { Skeleton } from '@atlassian/eoc-skeleton';

import { StyledFlex } from './styled';

export const LoadingRow = () => {
	return (
		<StyledFlex columnGap={3} alignItems="center">
			<Skeleton width={19.5} />
			<Skeleton width={3} />
		</StyledFlex>
	);
};
